/**
 * In-memory token storage (no localStorage for security).
 * Tokens are lost on page refresh - use refresh token cookie to restore session.
 * This prevents XSS attacks from stealing access tokens.
 *
 * The refresh token is stored as an HttpOnly cookie (set by backend),
 * which provides persistent sessions across page refreshes while maintaining security.
 */
let accessToken = null;
const listeners = new Set();

export const getAccessToken = () => {
  return accessToken;
};

export const setAccessToken = (token) => {
  accessToken = token || null;
  // Notify listeners (for React components that watch token changes)
  listeners.forEach(cb => {
    try {
      cb(accessToken);
    } catch (e) {
      console.error('Token listener error:', e);
    }
  });
};

export const clearAccessToken = () => {
  setAccessToken(null);
};

export const onTokenChange = (cb) => {
  listeners.add(cb);
  return () => listeners.delete(cb);
};

export const hasAccessToken = () => {
  return !!accessToken;
};
